var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"no-data"},[_c('img',{attrs:{"alt":"","src":require("../../assets/img/no-oder.png")}}),_c('p',[_vm._v("订单还是空的")]),_c('button',{staticClass:"go-shoping",on:{"click":function($event){return _vm.$router.push({ name: 'home' })}}},[_vm._v("去购物")])])
}
var staticRenderFns = []

export { render, staticRenderFns }